var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "loading-wrap",
      class: { start: !_vm.showLoading, hide: _vm.hideLoading },
    },
    [
      _c("div", { staticClass: "cg-wrap" }, [
        _c(
          "video",
          {
            staticClass: "video-bg",
            attrs: {
              preload: "auto",
              autoplay: "true",
              loop: "loop",
              playsinline: "",
              "webkit-playsinline": "",
              muted: "",
              volume: "0",
            },
            domProps: { muted: true },
          },
          [
            _c("source", {
              attrs: {
                src: "https://kg-web-cdn.kingsgroupgames.com/official-website/pc-landing/ss/static/video_11.mp4",
                type: "video/mp4",
              },
            }),
            _c("source", {
              attrs: {
                src: "https://kg-web-cdn.kingsgroupgames.com/official-website/pc-landing/ss/static/video_11.webm",
                type: "video/webm",
              },
            }),
          ]
        ),
      ]),
      _c("div", { staticClass: "logo" }),
      _c("div", { staticClass: "progress-wrap" }, [
        _c("div", { staticClass: "progress-text" }, [
          _c("div", { staticClass: "left" }, [
            _vm.loadingText
              ? _c("span", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.loadingText)),
                ])
              : _c("span", { staticClass: "text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.isEntering
                        ? _vm.$t("txt_loading")
                        : _vm.$t("text_waitting")
                    )
                  ),
                ]),
          ]),
          _c("div", { staticClass: "progress" }, [
            _vm._v(
              _vm._s(
                ((_vm.showProgress > 1 ? 1 : _vm.showProgress) * 100).toFixed(1)
              ) + "%"
            ),
          ]),
        ]),
        _c("div", { staticClass: "progress-box" }, [
          _c("div", {
            staticClass: "progress-bar",
            class: [_vm.progressClass],
            style: {
              width: `${(_vm.showProgress > 1 ? 1 : _vm.showProgress) * 100}%`,
            },
          }),
        ]),
      ]),
      !_vm.agreement && _vm.inCountry
        ? _c("AgreementPopup", { attrs: { country: _vm.country } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }